<template>
    <w-dialog
        :model-value="show"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-light1--bg white"
    >
        <table class="mb2 table-dashboard" width="100%">
            <thead>
                <tr>
                    <td>No. Resit</td>
                    <td>No Rujukan</td>
                    <td>Nama Pembayar</td>
                    <td>Cara Bayar</td>
                    <td>Amaun (RM)</td>
                    <td>Bank</td>
                    <td>Tarikh Bayar</td>
                    <td>Tarikh Batal</td>
                    <td>Status</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <w-input
                            v-model="form.no_resit"
                            :model-value="resit.no_resit"
                        >
                        </w-input>
                    </td>
                    <td>
                        <w-input
                            v-model="form.no_rujukan"
                            :model-value="resit.no_rujukan"
                        >
                        </w-input>
                    </td>
                    <td>
                        {{ resit.nama_pembayar }}
                        <div v-if="resit.no_tel_pembayar != null">
                            &nbsp;-{{ re.no_tel_pembayar }}
                        </div>
                    </td>
                    <td>
                        <z-lookup
                            :url="apiBaseUrl + '/cara-bayar'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_cara_bayaran_id"
                            :model-value="resit.lkp_cara_bayaran_id"
                        />
                    </td>
                    <td class="text-right">
                        <w-input
                            v-model="form.amaun"
                            :model-value="resit.amaun"
                            type="number"
                        />
                    </td>
                    <td>
                        <z-lookup
                            :url="apiBaseUrl + '/bank'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_bank_id"
                            :model-value="resit.lkp_bank_id"
                        />
                    </td>
                    <td>
                        <w-input
                            type="date"
                            @input="(e)=> setDate(e,'tarikh')"
                            :model-value="moment(resit.tarikh).format('YYYY-MM-DD')"
                        >
                        </w-input>
                        <w-input
                            type="time"
                            @input="(e)=>setTime(e,'tarikh')"
                            :model-value="moment(resit.tarikh).format('HH:mm')"
                        >
                        </w-input>
                    </td>
                    <td>
                        <w-input
                            type="date"
                            @input="(e)=> setDate(e,'tarikh_batal')"
                            :model-value="moment(form.tarikh_batal ?? null).format('YYYY-MM-DD')"
                        >
                        </w-input>
                        <w-input
                            type="time"
                            @input="(e)=>setTime(e,'tarikh_batal')"
                            :model-value="moment(form.tarikh_batal ?? null).format('HH:mm')"
                        >
                        </w-input>
                    </td>
                    <td>
                        <z-lookup
                            :url="apiBaseUrl + '/status-resit'"
                            :sort="false"
                            :cache="false"
                            :model-value="form.lkp_resit_status_id"
                        />
                    </td>
                </tr>
            </tbody>
        </table>

        <template #actions>
            <div class="spacer" />
            <w-button :loading="loading" @click="$emit('close')" text>
                Batal
            </w-button>
            <w-button :loading="loading" @click="simpan()" class="ml3">
                Simpan
            </w-button>
        </template>

        <w-alert error outline v-if="error"
            >{{ error }}</w-alert
        >
    </w-dialog>
</template>

<script setup>
import { ref, onMounted, onUpdated, watch, computed } from "vue";
import WaveUI from "wave-ui";
import moment from "moment";
import { moneyFormat } from "../helper/index";

const waveui = new WaveUI();
const emit = defineEmits(["close","onSuccess"]);
const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    resit: {
        type: Object,
    },
});
const apiBaseUrl = process.env.MIX_API_BASE_URL;
const loading = ref(false);

const dialog = ref({
    fullscreen: false,
    persistent: true,
    persistentNoAnimation: false,
    width: "90%",
});

const form = ref({})

const error = ref(null);

function setDate(e,field){
    const time = moment(form.value[field]).format('hh:mm:ss');
    form.value[field] = `${e} ${time}`;
}

function setTime(e,field){
    const date = moment(form.value[field]).format('YYYY-MM-DD');
    form.value[field] = `${date} ${e}:00`;
}

async function simpan() {
    loading.value = true;
    await axios({
        method: "post",
        url: `${apiBaseUrl}/cukai/kemaskini/kemaskini-resit`,
        responseType: "json",
        data: {...form.value, id: props.resit.id},
    })
        .then((e) => {
            waveui.notify({
                success: true,
                message: "Berjaya! Maklumat resit telah dikemaskini.",
                timeout: 3000,
            });
            emit('onSuccess',e.data);
        })
        .catch((e) => {
            waveui.notify({
                error: true,
                message: e.response.data.message,
                timeout: 3000,
            });
            error.value = e.response.data.message;
        })
        .finally((e) => {
            loading.value = false
        });
}


const cAmaun = computed({
    get: () => {
        return form.value.amaun ? moneyFormat(form.value.amaun) : 0
    },
    set: (value) => {
        value = value.replaceAll(',','')
        if(!value){
            value = '0.00'
        }

        const [dollar, cent] = value.split('.')
        
        if(!cent){
            form.value.amaun = parseFloat(value) / 100;
            return
        }
        if(cent.length > 2){
            form.value.amaun = parseFloat(value) * 10;
            return
        }
        form.value.amaun = parseFloat(value).toFixed(2);
        // const temp = `${dollar}.${cent}`;
    }
})
</script>
